export default __webpack_public_path__ + "063bd783cf180e10fa3d3530522d52d7.svg";